import { render, staticRenderFns } from "./button-download.vue?vue&type=template&id=7c639e85&scoped=true&"
import script from "./button-download.vue?vue&type=script&lang=js&"
export * from "./button-download.vue?vue&type=script&lang=js&"
import style0 from "./button-download.vue?vue&type=style&index=0&id=7c639e85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c639e85",
  null
  
)

export default component.exports